import {defineNestedRouteConfig} from '../nestedRouteUtils';
import {
  ORG_ALERTS,
  ORG_API_KEYS,
  ORG_BILLING,
  ORG_DASHBOARD,
  ORG_PROXY,
  ORG_ROLE_EDIT,
  ORG_ROLES_NEW,
  ORG_SERVICE_ACCOUNTS,
  ORG_SETTINGS,
  ORG_TEAMS,
  ORG_USER_ACTIVITY,
} from './orgPaths';

/**
 * Nested route definitions for organization pages and their RUM view names.
 * Used by HomePageWithData to resolve granular tracking for org routes.
 */
export const ORG_NESTED_ROUTES = defineNestedRouteConfig({
  exact: true,
  entries: [
    {paths: [ORG_DASHBOARD], datadogViewName: 'OrgDashboard'},
    {paths: [ORG_TEAMS], datadogViewName: 'OrgTeams'},
    {paths: [ORG_SERVICE_ACCOUNTS], datadogViewName: 'OrgServiceAccounts'},
    {paths: [ORG_API_KEYS], datadogViewName: 'OrgApiKeys'},
    {paths: [ORG_USER_ACTIVITY], datadogViewName: 'OrgActivity'},
    {paths: [ORG_BILLING], datadogViewName: 'OrgBilling'},
    {paths: [ORG_ALERTS], datadogViewName: 'OrgAlerts'},
    {
      paths: [ORG_ROLES_NEW, ORG_ROLE_EDIT, ORG_PROXY, ORG_SETTINGS],
      datadogViewName: 'OrgSettingsPage',
    },
  ],
});
